<template>
    <div class="about">
        <back></back>
        <div class="about-content">Not yet pls I'm still not ready :S</div>
    </div>
</template>

<style lang="scss">
    @import "../assets/css/variables";

    .about {
        height: 100%;
        width: 100%;
        font-family: 'Poiret One', cursive;
        color: #fff;
        text-align: center;

        .about-content {
            padding-top: 75px;
        }

    }
</style>


<script>
    export default {}
</script>
